import axios from 'axios';
import queryString from 'query-string';

import Storage from './storage';

// Intercept requests to ensure full error can be parsed
axios.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err?.response)
);

const ApiClient = {
  async get(path, params) {
    const token = await Storage.auth.getAuthToken();
    const requestPath = params
      ? `${path}?${queryString.stringify(params)}`
      : path;

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Expires: 0,
      Pragma: 'no-cache',
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_AUTH_API_URL}/${requestPath}`,
        { headers }
      );
      return res.data;
    } catch (err) {
      if (err.status.toString().startsWith('20')) {
        // Success
        return err;
      } else {
        return Promise.reject(err);
      }
    }
  },

  async post(path, data) {
    const token = path === 'login' ? null : await Storage.auth.getAuthToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Expires: 0,
      Pragma: 'no-cache',
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_AUTH_API_URL}/${path}`,
        JSON.stringify(data),
        {
          headers,
        }
      );
      return res.data;
    } catch (err) {
      if (err.status.toString().startsWith('20')) {
        // Success
        return err;
      } else {
        return Promise.reject(err);
      }
    }
  },

  async delete(path, data) {
    const token = await Storage.auth.getAuthToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Expires: 0,
      Pragma: 'no-cache',
    };

    let payload = JSON.stringify(data);
    if (path === 'logout') {
      payload = JSON.stringify({ token });
    }

    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_AUTH_API_URL}/${path}`,
        {
          headers,
          data: payload,
        }
      );
      return res.data;
    } catch (err) {
      if (err.status.toString().startsWith('20')) {
        // Success
        return err;
      } else {
        return Promise.reject(err);
      }
    }
  },

  async put(path, data) {
    const token = path === 'login' ? null : await Storage.auth.getAuthToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Expires: 0,
      Pragma: 'no-cache',
    };

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_AUTH_API_URL}/${path}`,
        JSON.stringify(data),
        {
          headers,
        }
      );
      return res.data;
    } catch (err) {
      if (err.status.toString().startsWith('20')) {
        // Success
        return err;
      } else {
        return Promise.reject(err);
      }
    }
  },
};

export default ApiClient;
